import React, { useEffect, useState } from "react";
import "./TopBanner.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const storageKey = "v2-banner-dismissed";

export default function TopBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(storageKey);
    if (!dismissed) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    if (visible) {
      document.body.classList.add("has-top-banner");
    } else {
      document.body.classList.remove("has-top-banner");
    }
    return () => document.body.classList.remove("has-top-banner");
  }, [visible]);

  const closeBanner = () => {
    setVisible(false);
    try {
      localStorage.setItem(storageKey, "1");
    } catch (e) {
      // ignore storage errors
    }
  };

  if (!visible) return null;

  return (
    <div className="top-banner" role="region" aria-label="Yangi versiya haqida banner">
      <div className="top-banner__content">
        <a
          className="top-banner__link"
          href="https://v2.zarnigorbiolog.uz"
          target="_blank"
          rel="noopener noreferrer"
        >
          Loyihaning yangi versiyasi mavjud — v2.zarnigorbiolog.uz. O‘tish uchun bosing.
        </a>
      </div>
      <button
        className="top-banner__close"
        onClick={closeBanner}
        aria-label="Bannerni yopish"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
}
